import { render, staticRenderFns } from "./callCenterList.vue?vue&type=template&id=600c281e&"
import script from "./callCenterList.vue?vue&type=script&lang=js&"
export * from "./callCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports